<!-- Active Directory -->
<form #adForm="ngForm" class="mt-20">
  <div>
    <div class="security-category">
      <h5>{{locale.LABEL_ACTIVE_DIRECTORY}} {{locale.LABEL_CONFIGURATION}}</h5>

      <!-- url -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3 required"
          for="wm-security-ad-url">{{locale.LABEL_ACTIVE_DIRECTORY_URL}}: </label>

        <div class="col-xs-9">
          <input id="wm-security-ad-url" type="text" placeholder={{security.placeholder.AD_url}}
            class="form-control app-textbox" name="wm-security-ad-url" [(ngModel)]="security.url"
            (ngModelOptions)="{'updateOn': 'change blur'}" (change)="onConfigChange()" />
        </div>
      </div>

      <!-- domain -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3" for="wm-security-ad-domain">{{locale.LABEL_DOMAIN}}: </label>

        <div class="col-xs-9">
          <input name="wm-security-ad-domain" type="text" placeholder={{security.placeholder.AD_domain}}
            class="form-control app-textbox" [(ngModel)]="security.domain"
            (ngModelOptions)="{'updateOn': 'change blur'}" (change)="onConfigChange()" />
          <p class="text-muted note-text">{{locale.LABEL_DOMAIN_HELP_MESSAGE}}</p>
        </div>
      </div>

      <!-- root dn -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3 required" for="wm-security-root-dn">{{locale.LABEL_ROOT_DN}}:
        </label>

        <div class="col-xs-9">
          <input name="wm-security-root-dn" type="text" placeholder={{security.placeholder.AD_rootDn}}
            class="form-control app-textbox" [(ngModel)]="security.rootDn"
            (ngModelOptions)="{'updateOn': 'change blur'}" (change)="onConfigChange()" />
        </div>
      </div>
      <hr>
    </div>

    <div class="security-category">
      <h5>{{locale.LABEL_USER}}</h5>

      <!-- user search pattern Field -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3 required"
          for="wm-security-ad-user-search-pattern">{{locale.LABEL_USER_SEARCH_PATTERN}}: </label>

        <div class="col-xs-9">
          <input name="wm-security-ad-user-search-pattern" class="form-control app-textbox"
            [(ngModel)]="security.userSearchPattern" (ngModelOptions)="{'updateOn': 'change blur'}"
            (change)="onConfigChange()" />
        </div>
      </div>

      <!-- test user dn -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3 required"
          for="wm-security-manager-dn">{{locale.LABEL_TEST_USER_NAME}}: </label>

        <div class="col-xs-9">
          <input name="wm-security-manager-dn" type="text" class="form-control app-textbox" name="wm-security-manager-dn"
            [(ngModel)]="security.managerDn" (ngModelOptions)="{'updateOn': 'change blur'}" (change)="onConfigChange()"
            autocomplete="off" />
          <label class="ml-5" *ngIf="security.managerDn && security.domain">&#64;{{security.domain}}</label>
        </div>
      </div>

      <!-- test user pwd -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3 required"
          for="wm-security-manager-pwd">{{locale.LABEL_TEST_USER_PASSWORD}}: </label>

        <div class="col-xs-9">
          <input name="wm-security-manager-pwd" type="password" class="form-control app-textbox"
            name="wm-security-manager-pwd" [(ngModel)]="security.managerPassword"
            (ngModelOptions)="{'updateOn': 'change blur'}" (change)="onConfigChange()" autocomplete="off" />
        </div>
      </div>

      <div class="form-group app-composite-widget clearfix">
        <div class="col-xs-9 col-xs-push-3">
          <button id="wm-security-activedir-test-connection" (click)="testActiveDirConnection()" class="button-primary"
            name="wm-security-activedir-test-connection">{{locale.LABEL_TEST_CONNECTION}}</button>
        </div>
      </div>
      <wms-message *ngIf="!hideMessage" hideclose="true" [scopeDataset]="message"></wms-message>
      <hr>
    </div>

    <div class="security-category">
      <h5>{{locale.LABEL_ROLE}}</h5>

      <!-- Search User Role-->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3">{{locale.LABEL_SEARCH_USER_ROLE}}: </label>
        <div class="col-xs-9">
          <wms-toggle id="wm-security-ad-user-roles-toggle" class="switch" name="wm-role-config"
            [model]="security.roleMappingEnabled" [onLabel]="'On'" [offLabel]="'Off'"
            (onChange)="security.roleMappingEnabled = $event;"></wms-toggle>
        </div>
      </div>

      <div *ngIf="security.roleMappingEnabled">
        <div class="form-group app-composite-widget clearfix">
          <label class="control-label app-label col-xs-3"
            for="wm-sec-select-ad-search-user-role-provider">{{locale.LABEL_SELECT_USER_ROLE_PROVIDER}}: </label>

          <div class="col-xs-9">
            <select id="wm-sec-select-ad-search-user-role-provider" class="form-control app-select"
              name="wm-sec-select-ad-search-user-role-provider" [(ngModel)]="security.roleProvider">
              <option *ngFor="let option of security.userADRoleProviders">{{option}}</option>
            </select>
          </div>
        </div>

        <div [ngSwitch]="security.roleProvider">
          <div *ngSwitchCase="'Active Directory'">
            <div class="form-group app-composite-widget clearfix">
              <label class="control-label app-label col-xs-3"
                for="wm-sec-grp-role-attr">{{locale.LABEL_GROUP_ROLE_ATTRIBUTE}}: </label>

              <div class="col-xs-9">
                <input name="wm-sec-grp-role-attr" class="form-control app-textbox" readonly
                  [(ngModel)]="security.adGroupRoleAttribute" />
              </div>
            </div>
          </div>
          <div class="security-sub-category" *ngSwitchCase="'Database'">
            <!-- Roles By SQL Query -->
            <wms-database [securityProps]="securityProps" [authInfo]="authInfo"></wms-database>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>